import { render, staticRenderFns } from "./02_curtain_lace.vue?vue&type=template&id=b88b4d40&scoped=true&"
import script from "./02_curtain_lace.vue?vue&type=script&lang=js&"
export * from "./02_curtain_lace.vue?vue&type=script&lang=js&"
import style0 from "./02_curtain_lace.vue?vue&type=style&index=0&id=b88b4d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88b4d40",
  null
  
)

export default component.exports